import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { Pagination } from '@app/shared/components/api/models/pagination.model';
import { MenuItem, MessageService, ConfirmationService } from 'primeng/api';
import { FilterItem } from '../../../../../../shared/components/api/models/filterItem.model';
import { AdminDetalheCampanhaComponent } from '../admin-detalhe-campanha/admin-detalhe-campanha.component';
import { DrawerModule } from 'primeng/drawer';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { SkeletonLoaderComponent } from '@app/shared/components/skeleton-loader/skeleton-loader.component';
import { CampanhaDestaqueService } from '@app/shared/components/api/services/campanha-destaque.service';
import { CardCampanhaDashAdminComponent } from '@app/shared/components/card-campanha-dash-admin/card-campanha-dash-admin.component';
import { CategoriaService } from '@app/shared/components/api/services/categoria.service';
import { EnumService } from '@app/shared/components/api/services/enum.service';
import { forkJoin } from 'rxjs';
import { ProvinciaService } from '@app/shared/components/api/services/provincia.service';
import { Menu } from 'primeng/menu';

import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';

@Component({
  selector: 'app-lista-campanhas-destaques',
  imports: [
    CommonModule,
    CardCampanhaDashAdminComponent,
    DataVoidComponent,
    PaginatorControlComponent,
    AdminDetalheCampanhaComponent,
    DrawerModule,
    SkeletonLoaderComponent,
    SearchBarComponent,
  ],
  standalone: true,
  providers: [
    CampanhaDestaqueService,
    CategoriaService,
    EnumService,
    ProvinciaService,
  ],
  templateUrl: './lista-campanhas-destaques.component.html',
  styleUrl: './lista-campanhas-destaques.component.scss'
})
export class ListaCampanhasDestaquesComponent implements OnInit {
  [x: string]: any;
  // injections 
  private readonly fb = inject(FormBuilder);
  private readonly messageService = inject(MessageService);
  private readonly confirmationService = inject(ConfirmationService);
  private readonly campanhaDestaqueService = inject(CampanhaDestaqueService);
  private readonly categoriaService = inject(CategoriaService);
  private readonly enumService = inject(EnumService)
  private readonly provinciaService = inject(ProvinciaService);
  categoriaList: any[] = [];
  indicators: any[] = [];
  estadoCampanhaOptions: any[] = [];
  provinciaList: any[] = [];
  estadoApoioList: any[] = [];
  tipofinanciamentoList: any[] = [];
  visible: boolean = false;
  loading: boolean = false;
  loadCampanhas: boolean = false;
  campanha: any;
  campanhaID: any;
  currentFilters: any = {};
  pagination: Pagination<any> = new Pagination<any>();

  filters: FilterItem[] = [
    {
      type: 'dropdown',
      controlName: 'CategoriaId',
      options: this.categoriaList,
      placeholder: 'Sector',
      optionLabel: 'label',
      optionValue: 'value',
    },
    {
      type: 'dropdown',
      controlName: 'ProvinciaID',
      options: this.provinciaList,
      placeholder: 'Provincia',
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'EstadoCampanhaENUM',
      options: this.estadoCampanhaOptions,
      placeholder: 'Seleccione o estado',
      optionLabel: 'label',
      optionValue: 'id'
    },
    {
      type: 'dropdown',
      controlName: 'TipoFinanciamentoENUM',
      options: this.tipofinanciamentoList,
      placeholder: 'Seleccione o tipo de financiamento',
      optionLabel: 'label',
      optionValue: 'id'
    }
  ];

  ngOnInit(): void {
    this.loadDropdowns();
    this.getAllCampanhas();
  }

  getAllCampanhas(filters?: any) {
    this.loadCampanhas = true;
    const params = {
      ...this.currentFilters,
      ...filters,
      PageSize: this.pagination.pageSize || 5,
      PageNumber: this.pagination.pageNumber || 1,
      OrderBy: 'id desc',
    };

    this.campanhaDestaqueService.list(params).subscribe({
      next: (res) => {
        this.pagination = new Pagination<any>().deserialize(res);
        this.loadCampanhas = false;
      },
      error: (err) => {
        console.error(err);
        this.loadCampanhas = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Falha',
          detail: 'Não foi possível carregar campanhas',
          life: 5000
        });
      }
    });
  }

  loadDropdowns() {
    forkJoin({
      estadoCampanha: this.enumService.getAllEstadoCampanha(),
      estadoApoio: this.enumService.getAllEstadoApoio(),
      TipoFinanciamentoENUM: this.enumService.getAllTipoFinanciamento(),
      categoria: this.categoriaService.list({ pageSize: 100 }),
      provincia: this.provinciaService.list({ pageSize: 100 }),
    }).subscribe((response) => {
      // Enums
      if (response.estadoCampanha?.data) {
        this.estadoCampanhaOptions = Object.entries(response.estadoCampanha.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          })
        );
        this.filters[2].options = this.estadoCampanhaOptions;
      }
      if (response.estadoApoio?.data) {
        this.estadoApoioList = Object.entries(response.estadoApoio.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          })
        );
      }
      if (response.TipoFinanciamentoENUM?.data) {
        this.tipofinanciamentoList = Object.entries(response.TipoFinanciamentoENUM.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          })
        );
        this.filters[3].options = this.tipofinanciamentoList;
      }
      // Listas comuns
      if (response.categoria?.data) {
        this.categoriaList = response.categoria.data.map((item: any) => ({
          label: item.descricao,
          value: item.id,
        }));
        this.filters[0].options = this.categoriaList;
      }
      if (response.provincia?.data) {
        this.provinciaList = response.provincia.data.map((item: any) => ({
          label: item.descricao,
          id: item.id,
        }));
        this.filters[1].options = this.provinciaList;
      }
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getAllCampanhas();
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ''
      )
    );

    this.currentFilters = filters; // guardar filtros ja aplicados
    this.getAllCampanhas();
  }

  verDetalhe(campanha: any) {
    this.campanha = campanha;
    this.visible = true;
  }

  removerDestaque(campanha: any) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja remover o destaque desta campanha?',
      header: 'Confirmação',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Sim, remover',
      },
      accept: () => {
        this.loading = true;

        this.campanhaDestaqueService.removeDestaque(campanha.id).subscribe({
          next: (res) => {
            this.loading = false;
            if (res.retorno.codigo === 200) {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Destaque removido com sucesso!',
                life: 5000,
              });
              setTimeout(() => {
                this.getAllCampanhas();
              }, 2500);
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Falha',
                detail: `${res.retorno.mensagem}` || 'Não foi possível remover o destaque',
                life: 5000,
              });
            }
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Ocorreu um erro ao remover o destaque. Tente novamente.',
              life: 5000,
            });
            console.error(err);
          }
        });
      },
      reject: () => {
        // Ação ao cancelar (se necessário
      },
    });
  }

  openedMenu: Menu | null = null;

  setOpenedMenu(menu: Menu) {
    if (this.openedMenu && this.openedMenu !== menu) {
      this.openedMenu.hide();
    }
    this.openedMenu = menu;
  }

  getActionsByEstado(campanha: any): MenuItem[] {
    const baseActions: MenuItem[] = [
      {
        label: 'Ver detalhes',
        icon: 'pi pi-eye',
        command: (event) => {
          this.verDetalhe(campanha);
        }
      },
      {
        label: 'Remover Destaque',
        icon: 'pi pi-star',
        command: () => this.removerDestaque(campanha),
      },
    ];

    return baseActions;
  }

}
